export const saveToStorage = (key, value) => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Error saving to storage", error);
  }
};

// Utility function to get data from localStorage
export const getFromStorage = (key) => {
  try {
    const serializedValue = localStorage.getItem(key);
    if (!serializedValue) return null;

    const parsedValue = JSON.parse(serializedValue); // Parse the outer JSON

    // Automatically parse nested JSON strings if necessary
    const deepParse = (obj) => {
      if (typeof obj === "string") {
        try {
          return deepParse(JSON.parse(obj)); // Recursively parse if it's a valid JSON string
        } catch {
          return obj; // Return as is if parsing fails
        }
      } else if (typeof obj === "object" && obj !== null) {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [key, deepParse(value)])
        );
      }
      return obj;
    };

    return deepParse(parsedValue);
  } catch (error) {
    console.error("Error getting from storage", error);
    return null;
  }
};

// Utility function to clear specific data from localStorage
export const clearStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error clearing storage", error);
  }
};
